import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import resources from 'virtual:i18next-loader';

i18n.use(initReactI18next).init({
  resources,
  lng: 'pt',
  fallbackLng: 'pt',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  debug: import.meta.env.DEV,
});

export default i18n;
